import { VIDEO_TIME_UPDATE, SET_VIDEO_STATE,
  VIDEO_SELECT_MEDIA_INDEX, VIDEO_SET_ABSOLUTETIME } from '../actions/tools';

const initialState = {
  time: 0,
  duration: 0,
  playbackRate: 1,
  state: undefined,
};

function updateVideoTime(state, action) {
  const { time, duration, playbackRate } = action;
  return { ...state, time, duration, playbackRate };
}

function setVideoState(state, action) {
  if (state.state !== action.state) {
    state.state = action.state;
    return { ...state };
  }
  return state;
}

function selectMediaIndex(state) {
  if (state.state === 'ended') {
    state.time = undefined;
    state.state = 'playing';
    return { ...state };
  }
  return state;
}

function setAbsoluteTime(state) {
  state.time = undefined;
  return { ...state };
}

export default function reduceVideo(state = initialState, action) {
  switch (action.type) {
    case VIDEO_TIME_UPDATE:
      return updateVideoTime(state, action);
    case SET_VIDEO_STATE:
      return setVideoState(state, action);
    case VIDEO_SELECT_MEDIA_INDEX:
      return selectMediaIndex(state, action);
    case VIDEO_SET_ABSOLUTETIME:
      return setAbsoluteTime(state, action);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/video.js